import { SbBlokData, storyblokEditable } from "@storyblok/react";
import { FC } from "react";
import { DynamicSeo } from "seo";
import { BlogLayout } from "ui";
import { transformDate } from "../transformDate";
import { StoryBaseProps } from "../types/StoryBaseProps";
import { StoryImageProps } from "../types/StoryImageProps";
import { DynamicComponentRepeater } from "./DynamicComponentRepeater";

export interface PostProps {
	title?: string;
	teaser?: string;
	date?: string;
	content?: SbBlokData[];
	image?: StoryImageProps;
}

interface StoryPostProps extends StoryBaseProps<PostProps> {}

export const StoryPost: FC<StoryPostProps> = ({ blok }) => {
	const { title, teaser, _uid, date, image, content } = blok;
	return (
		<>
			<DynamicSeo
				title={title}
				description={teaser}
				type={"article"}
				subtitle={transformDate(date)}
				datePublished={date}
				imageSrc={image?.filename}
			/>
			<BlogLayout
				title={title}
				imageAlt={image?.alt}
				imageSrc={image?.filename}
				dateTimeStamp={date}
				date={transformDate(date)}
				teaser={teaser}
				{...storyblokEditable(blok)}
				key={_uid}>
				<DynamicComponentRepeater content={content} />
			</BlogLayout>
		</>
	);
};
